import React from 'react'

const AlertCircleIcon: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="12" fill="#1F0812" />
            <path d="M11.9998 17.8334C15.2215 17.8334 17.8332 15.2217 17.8332 12C17.8332 8.77836 15.2215 6.16669 11.9998 6.16669C8.77818 6.16669 6.1665 8.77836 6.1665 12C6.1665 15.2217 8.77818 17.8334 11.9998 17.8334Z" stroke="white" stroke-width="0.875" />
            <path d="M11.9956 13.75H12.0009" stroke="white" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12 12V9.66669" stroke="white" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

    )
}

export default AlertCircleIcon;